import { useState, useEffect, useCallback } from 'react';

export const usePWAInstall = () => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  
  useEffect(() => {
    // Detecta iOS
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);
    
    // Verifica se já está instalado (standalone mode)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
      || window.navigator.standalone 
      || document.referrer.includes('android-app://');
    setIsInstalled(isStandalone);
    
    // Captura o evento beforeinstallprompt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      setIsInstallable(true);
    };
    
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    
    // Detecta quando o app é instalado
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setInstallPrompt(null);
      setIsInstallable(false);
    });
    
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);
  
  const promptInstall = useCallback(async () => {
    if (!installPrompt) {
      return { outcome: 'unavailable' };
    }
    
    try {
      installPrompt.prompt();
      const { outcome } = await installPrompt.userChoice;
      
      if (outcome === 'accepted') {
        setIsInstalled(true);
        setInstallPrompt(null);
        setIsInstallable(false);
      }
      
      return { outcome };
    } catch (error) {
      console.error('Erro ao instalar PWA:', error);
      return { outcome: 'error', error };
    }
  }, [installPrompt]);
  
  return {
    isInstallable,
    isInstalled,
    isIOS,
    promptInstall
  };
};

export default usePWAInstall;
